import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        appblelockrecordarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_APPBLELOCKRECORDLIST: (state, obj) => {

            state.total = obj.total
            state.appblelockrecordarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.appblelockrecordarr.splice(index,1)
        },
        CLEAR_APPBLELOCKRECORDLIST: (state) => {

            state.total = 0
            state.appblelockrecordarr=[]

        },


    },
    actions: {
        async getLockrecord({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getlockrecord(params)
            if (code == 200) {
                commit('SET_APPBLELOCKRECORDLIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}